import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { I } from "../../Components/CMI/icons";
import { setVista } from "../../slices/filters/reducer";
import { useCMI } from "./cmi-context";

const VISTAS = [
  { id: "anual",   label: "Anual" },
  { id: "mensual", label: "Mensual" },
];

export const PageHead = ({ icon: Ico, title, sub, screenId, actions }) => {
  const dispatch = useDispatch();
  const vista = useSelector((s) => s.Filters.vista);
  const { openAI, refreshing, onRefresh } = useCMI();
  const showDashboardControls = !!screenId;

  return (
    <div className="page-head">
      <div>
        <div className="page-title">
          {Ico ? <span className="ico"><Ico size={24} /></span> : null}
          <h1>{title}</h1>
        </div>
        {sub ? <div className="page-sub">{sub}</div> : null}
      </div>
      <div className="page-actions">
        {showDashboardControls ? (
          <>
            <button className="btn-ai-pill" onClick={() => openAI(screenId)} title="Generar resumen ejecutivo con IA">
              <span className="ic"><I.Sparkle size={12} /></span>
              Resumen IA
            </button>
            <div className="seg" role="tablist" aria-label="Vista">
              {VISTAS.map((v) => (
                <button key={v.id} className={vista === v.id ? "active" : ""} onClick={() => dispatch(setVista(v.id))}>{v.label}</button>
              ))}
            </div>
            <button className={`btn btn-refresh ${refreshing ? "spinning" : ""}`} onClick={onRefresh}>
              <I.Refresh size={16} />
              Actualizar
            </button>
          </>
        ) : null}
        {actions || null}
      </div>
    </div>
  );
};

export const SectionHead = ({ icon: Ico, title, sub, right, small }) => (
  <div className={`section${small ? ' section-sm' : ''}`}>
    <div>
      <h2>
        {Ico ? <Ico size={small ? 16 : 20} /> : null}
        {title}
      </h2>
      {sub ? <div className="sub" style={{ marginTop: 4 }}>{sub}</div> : null}
    </div>
    {right ? <div>{right}</div> : null}
  </div>
);

export const Footer = () => (
  <div className="foot">
    <span>{new Date().getFullYear()} © Cucalón Estévez y Asociados.</span>
    <span>Design &amp; Develop by ContentFlow</span>
  </div>
);

export default PageHead;
